/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_DismissInputs */

const en_us2_coach_mic_dismiss = /** @type {(inputs: Coach_Mic_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const pt_br2_coach_mic_dismiss = /** @type {(inputs: Coach_Mic_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar aviso`)
};

const es_419_coach_mic_dismiss = /** @type {(inputs: Coach_Mic_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar aviso`)
};

const pt_pt2_coach_mic_dismiss = /** @type {(inputs: Coach_Mic_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar aviso`)
};

const fr_fr2_coach_mic_dismiss = /** @type {(inputs: Coach_Mic_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_de2_coach_mic_dismiss = /** @type {(inputs: Coach_Mic_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_it2_coach_mic_dismiss = /** @type {(inputs: Coach_Mic_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi avviso`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Coach_Mic_DismissInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_dismiss = /** @type {((inputs?: Coach_Mic_DismissInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_DismissInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_dismiss(inputs)
	if (locale === "es-419") return es_419_coach_mic_dismiss(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_dismiss(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_dismiss(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_dismiss(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_dismiss(inputs)
	return en_us2_coach_mic_dismiss(inputs)
});
export { coach_mic_dismiss as "coach-mic.dismiss" }